module.exports = __webpack_public_path__ + "static/media/IMG_4372.db1ed42f.jpg";